<template>
  <div id="app">

    <router-view/>

    <mt-tabbar v-model="selected" :fixed="true" v-if="show_mt_tabbar">
      <mt-tab-item id="scan">
        <div class="svg-img">
          <svg style="width: 22px;padding-top: 2px;" xmlns="http://www.w3.org/2000/svg" class="ant-icon" viewBox="64 64 896 896"><path d="M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path></svg>
        </div>
        Scaning
      </mt-tab-item>
<!--      <mt-tab-item id="shipments">-->
<!--        <div class="svg-img">-->
<!--          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="svg-icon fa-svg-icon svg-fa-assignment" width="25" height="25" viewBox="0 0 24 24"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"></path></svg>-->
<!--        </div>-->
<!--        Export Handling-->
<!--      </mt-tab-item>-->
      <!-- <mt-tab-item id="completedShipments">
        <div class="svg-img">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="svg-icon fa-svg-icon svg-fa-assignment_turned_in" width="25" height="25" viewBox="0 0 24 24"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"></path></svg>
        </div>
        Completed Shipments
      </mt-tab-item> -->
      <mt-tab-item id="nsappShipments" @click.native="customModuleClick">
        <div class="svg-img">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="svg-icon fa-svg-icon svg-fa-assignment_turned_in" width="25" height="25" viewBox="0 0 24 24"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"></path></svg>
        </div>
        Custom Module
      </mt-tab-item>
      <mt-tab-item id="setting">
        <div class="svg-img">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="svg-icon fa-svg-icon svg-fa-build" width="25" height="25" viewBox="0 0 24 24"><path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"></path></svg>
        </div>
        Setting
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  methods: {
    handleClick: function () {
      this.$toast('Hello world!')
    },
    customModuleClick () {
      this.$router.push({
        path: '/nsapp/mobile/shipments/guide'
      })
    },
    reload: function () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  data () {
    return {
      selected: 'nsappShipments',
      show_mt_tabbar: true,
      isRouterAlive: true
    }
  },
  watch: {
    selected (newval, oldval) {
      switch (newval) {
        case 'shipments':
          this.$router.push({
            path: '/eh/mobile/shipments'
          })
          break
        case 'setting':
          this.$router.push({
            path: '/eh/mobile/setting'
          })
          break
        // case 'completedShipments':
        //   this.$router.push({
        //     path: '/eh/mobile/shipments/completed'
        //   })
        //   break
        case 'nsappShipments':
          this.$router.push({
            path: '/nsapp/mobile/shipments/guide'
          })
          break
        case 'scan':
          this.$router.push({
            path: '/eh/mobile/scan'
          })
          break
      }
    },
    '$route' (to, from) {
      if (to.name === 'Login' || to.name === 'Login2') {
        this.show_mt_tabbar = false
      } else {
        this.show_mt_tabbar = true
      }
    }
  },
  created () {
    this.$router.push({
      path: window.location.pathname
    })

    switch (window.location.pathname) {
      case '/eh/mobile/shipments':
        this.selected = 'shipments'
        break
      // case '/eh/mobile/shipments/completed':
      //   this.selected = 'completedShipments'
      //   break
      case '/nsapp/mobile/shipments':
        this.selected = 'nsappShipments'
        break
      case '/eh/mobile/setting':
        this.selected = 'setting'
        break
      case '/eh/mobile/scan':
        this.selected = 'scan'
        break
    }
  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 40px;
  margin-bottom: 70px;
}

body {
   margin: 0;
   padding: 0;
}

.svg-img {
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue